import * as React from 'react';

import FileUpload32 from './FileUpload32';

export const fileUpload32 = () => <FileUpload32 />;

export default {
    title: 'Icon|Content|FileUpload32',
    component: FileUpload32,
    parameters: {
        notes: "`import FileUpload32 from 'box-ui-elements/es/icon/content/FileUpload32';`",
    },
};
